import { useCallback } from "react";

export const useBoxStyling = (
  box,
  isSelected,
  isAdmin,
  isDragging,
  isExerciseAttempted,
  showAnswers,
  isPx
) => {
  const getBoxClassName = useCallback(() => {
    const classNames = ["input-box"];

    if (isSelected && isAdmin) {
      classNames.push("selected-admin");
    }

    if (
      isExerciseAttempted &&
      box.answer === null &&
      box.isAnswerCorrect !== null &&
      !showAnswers
    ) {
      classNames.push(
        box.isAnswerCorrect === true
          ? "correct"
          : box.isAnswerCorrect === "unselected"
          ? "unselected"
          : box.isAnswerCorrect === false
          ? "incorrect"
          : ""
      );
    }

    if (showAnswers) {
      if (
        box?.isAnswerCorrect &&
        ["single-select", "multi-select"].includes(box.type)
      ) {
        classNames.push("correct");
      } else if (
        !["single-select", "multi-select", "descriptive"].includes(box.type)
      ) {
        classNames.push("correct");
      }
    }

    if (
      box.answer !== null &&
      box.answer &&
      ["single-select", "multi-select"].includes(box.type)
    ) {
      classNames.push("selected");
    } else if (
      isSelected &&
      !["single-select", "multi-select"].includes(box.type)
    ) {
      classNames.push("selected");
    }

    if (isDragging) {
      classNames.push("dragging");
    }

    return classNames.join(" ");
  }, [box, isSelected, isAdmin, isDragging, isExerciseAttempted, showAnswers]);

  const getBoxStyle = useCallback(
    () => ({
      position: "absolute",
      left: `${box.boxCoords.x}${isPx ? "px" : "%"}`,
      top: `${box.boxCoords.y}${isPx ? "px" : "%"}`,
      width: `${box.boxCoords.width}${isPx ? "px" : "%"}`,
      height: `${box.boxCoords.height}${isPx ? "px" : "%"}`,
      cursor: isAdmin ? (isDragging ? "grabbing" : "grab") : "pointer",
      zIndex: isSelected ? 10 : 1,
    }),
    [box.boxCoords, isAdmin, isDragging, isSelected, isPx]
  );

  return {
    className: getBoxClassName(),
    style: getBoxStyle(),
  };
};
